export default class Config {
    static app_token = "550f40e0c93c93dc3dd49c3e9ab09087acfb5f11";
    static app_name = "PATIENT";
    static base_url = process.env.VUE_APP_BASE_URL_API ?? "https://api.ubbimed.com.br";
    static base_url_ws = process.env.VUE_APP_BASE_URL_WS ?? "api.ubbimed.com.br";
    static site_url = process.env.VUE_APP_SITE_URL ?? "https://ubbimed.com.br";
    static site_url_patient = process.env.VUE_APP_SITE_URL_PATIENT ?? "https://patient.ubbimed.com.br";
    static protocol_ws = process.env.VUE_APP_PROTOCOL_WS ?? "wss";
    static timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
}